import React, { useEffect, useState } from 'react'
import AnnounceTable from './announceTable'
import useHome from '../../context/useHome'

const Scope3 = () => {
    const { homeData } = useHome()
    const [count, setCount] = useState(0)
    useEffect(() => {
        const _count = homeData?.jobListJobReqList ? homeData?.jobListJobReqList?.length : 0
        setCount(_count)
    }, [homeData])

    return (
        <div className='home-scope3 px-4'>
            <div className='container margin-auto div-title'>
                <div className="title">ประกาศงาน</div>
                <div className="text-all color-gray6">{`ผลการค้นหา พบ ( ${count} ) รายการ`}</div>
            </div>
            <div className="div-table container margin-auto p-3">
                <AnnounceTable />
            </div>
        </div>
    )
}

export default Scope3